<template>
  <el-tabs v-model="activeActiveCom" type="card" @tab-click="handleTabs">
    <el-tab-pane name="Attribute" :label="$t('integration.attribute')"></el-tab-pane>
    <el-tab-pane name="Application" :label="$t('integration.application')"></el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  props: ['activeCom'],
  computed: {
    activeActiveCom: {
      get: function () {
        return this.activeCom
      },
      set: function (val) {
        this.$emit('update:activeCom', val)
      }
    }
  },
  methods: {
    handleTabs({ name }) {
      this.$emit('handleTabs', name)
    }
  }
}
</script>

<style>
</style>